<template>
	<div class="icon-title">
		<v-img class="icon-title__icon mb-3" :src="src" :width="width" :style="{ 'margin-left': useoffset }" v-if="iconVisible" />
		<h6 class="icon-title__title primary--text" :style="{ 'font-size': size }">
			<slot></slot>
		</h6>
		<h3 class="mt-2 text--primary" v-if="description">
			{{ description }}
		</h3>
	</div>
</template>

<script>
export default {
	name: 'icon-title',
	props: {
		description: String,
		size: {
			type: null,
			default: '24px'
		},
		src: String,
		width: {
			type: null,
			default: '100'
		},
		iconVisible: {
			type: Boolean,
			default: true
		},
		offset: {
			type: Boolean,
			default: true
		}
	},
	computed: {
		useoffset() {
			if (this.$props.offset) {
				return parseInt(this.width) ? `-${parseInt(this.width) / 200}em` : '-0.75em';
			}
			return 0;
		}
	}
};
</script>

<style lang="scss">
.icon-title {
	&__icon {
		flex-grow: 0 !important;
	}

	&__title {
		font-family: 'niveau-grotesk' !important;
		font-weight: 700;
	}
}
</style>
